"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

var _collapse = _interopRequireDefault(require("antd/lib/collapse"));

var _table = _interopRequireDefault(require("antd/lib/table"));

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _forum = require("../../redux/forum/forum.types");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const initialState = {};

const rowClassName = (record, index) => {
  return index % 2 === 0 ? 'tr-even-color' : 'tr-odd-color';
};

class PostsTable extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;

    this.navigateToPost = post => {
      const {
        studyId
      } = this.props;
      this.props.updateRecentActivitySelectedPostId(post.id);
      this.props.history.push(`/study/${studyId}/forums/recentActivity`);
    };

    this.columns = [{
      title: 'ID',
      render: (val, post) => {
        return /*#__PURE__*/_react.default.createElement(_button.default, {
          type: "link",
          onClick: () => this.navigateToPost(post)
        }, val);
      },
      dataIndex: 'id',
      key: 'id',
      sorter: (a, b) => a.id - b.id
    }, {
      title: 'Date',
      dataIndex: 'createDate',
      key: 'createDate',
      render: date => (0, _moment.default)(date).calendar(),
      sorter: (a, b) => {
        return (0, _moment.default)(a.createDate || 0).unix() - (0, _moment.default)(b.createDate || 0).unix();
      },
      defaultSortOrder: 'descend'
    }, {
      title: 'Topic',
      dataIndex: 'topic',
      key: 'topic',
      // render: renderParticipantLink,
      sorter: (a, b) => `${a.topic}`.localeCompare(b.topic)
    }, {
      title: 'Post',
      dataIndex: 'body',
      key: 'body',
      // render: renderParticipantLink,
      sorter: (a, b) => `${a.body}`.localeCompare(b.body)
    }, {
      title: 'Flags',
      dataIndex: 'flagCount',
      sorter: (a, b) => a.id - b.id
    }, {
      title: 'Hidden?',
      dataIndex: 'isHidden',
      filters: [{
        text: 'yes',
        value: 1
      }, {
        text: 'no',
        value: 0
      }],
      onFilter: (value, record) => record.isHidden === value,
      render: val => val === 0 ? 'no' : 'yes',
      sorter: (a, b) => a.id - b.id
    }, {
      title: 'Comments',
      dataIndex: 'commentCount',
      sorter: (a, b) => a.id - b.id
    }, {
      title: 'Thumbusups',
      dataIndex: 'thumbsupsCount',
      sorter: (a, b) => a.id - b.id
    }, {
      title: 'Favorites',
      dataIndex: 'favoritesCount',
      sorter: (a, b) => a.id - b.id
    } // , {
    //   title: 'createdByParticipantId',
    //   dataIndex: 'createdByParticipantId',
    //   key: 'createdByParticipantId',
    //   sorter: (a: any, b: any) => `${a.createdByParticipantId}`.localeCompare(b.createdByParticipantId)
    // }
    ];
  }

  render() {
    const {
      Panel
    } = _collapse.default;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: "search-results-container"
    }, /*#__PURE__*/_react.default.createElement(_table.default, {
      columns: this.columns,
      dataSource: this.props.posts,
      pagination: false,
      rowClassName: rowClassName,
      rowKey: "id"
    }));
  }

}

PostsTable.defaultProps = {};

const mapStateToProps = state => {
  return {
    studyId: selectors.getRequestedStudyId(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateRecentActivityScroll: scrollTop => dispatch((0, _forum.updateRecentActivityScroll)(scrollTop)),
    updateRecentActivitySelectedPostId: selectedPostId => dispatch((0, _forum.updateRecentActivitySelectedPostId)(selectedPostId))
  };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PostsTable));

exports.default = _default;